(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__info-container').forEach(function (container) {
      var qty = container.querySelector('.product-form__quantity');
      var addToCartBtn = container.querySelector('.product-form__submit');
      if (!qty || !addToCartBtn || qty.closest('.product-form__row')) return;

      var row = document.createElement('div');
      row.className = 'product-form__row';

      qty.parentNode.insertBefore(row, qty);
      row.appendChild(qty);
      row.appendChild(addToCartBtn);
    });
  });
})();
